import { render, staticRenderFns } from "./CustomerOtherList.vue?vue&type=template&id=08ab6fcf&scoped=true&"
import script from "./CustomerOtherList.vue?vue&type=script&lang=js&"
export * from "./CustomerOtherList.vue?vue&type=script&lang=js&"
import style0 from "./CustomerOtherList.vue?vue&type=style&index=0&id=08ab6fcf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08ab6fcf",
  null
  
)

component.options.__file = "CustomerOtherList.vue"
export default component.exports